var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Text from "../Text/Text";
import Cone from "../../svg/cone";
import styled from "styled-components";
import { useTheme } from "../ThemeProvider/ThemeProvider";
var StyledNotFoundCtr = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n"])), function (props) { return props.$width; }, function (props) { return props.$height; }, function (props) { return props.$colorPalette.primary.grayScale[10]; }, function (props) { return props.$colorPalette.primary.grayScale[0]; });
var NotFound = function (_a) {
    var name = _a.name, _b = _a.width, width = _b === void 0 ? "800px" : _b, iconWidth = _a.iconWidth, _c = _a.height, height = _c === void 0 ? "800px" : _c, iconHeight = _a.iconHeight, style = _a.style, _d = _a.notFoundText, notFoundText = _d === void 0 ? "Page Not Found" : _d;
    var colorPalette = useTheme().theme.colorPalette;
    var NotFoundComponent = null;
    switch (name) {
        case "Cone":
            NotFoundComponent = Cone;
            break;
        default:
            NotFoundComponent = Cone;
    }
    var NotFoundElement = typeof notFoundText === "string" ? (_jsx(Text, __assign({ variant: "h4" }, { children: notFoundText }))) : (notFoundText);
    return (_jsxs(StyledNotFoundCtr, __assign({ "$width": width, "$height": height, "$colorPalette": colorPalette, style: style }, { children: [_jsx(NotFoundComponent, { width: iconWidth, height: iconHeight }), NotFoundElement] })));
};
export default NotFound;
var templateObject_1;
